import { Entity } from '@/models/entity';
import { Constants } from '@/common/Constants';

export abstract class EntityStatusService<T extends Entity> {
	public entityStatus: string;
	protected entity: T;

	constructor(entity: T) {
		this.entityStatus = entity.status ?? '';
		this.entity = entity;
	}

	public abstract entityReadyForSignOff(): boolean;

	public get entityLive(): boolean {
		return this.entityStatus === Constants.ENTITY_STATE_LIVE;
	}

	public get entityNotLiveYet(): boolean {
		return [
			Constants.ENTITY_STATE_PENDING,
			Constants.ENTITY_STATE_INSTALL,
			Constants.ENTITY_STATE_SIGNOFF,
		].includes(this.entityStatus);
	}

	public get entityPreSignOff(): boolean {
		return [Constants.ENTITY_STATE_PENDING, Constants.ENTITY_STATE_INSTALL].includes(
			this.entityStatus,
		);
	}

	public get entityInactive(): boolean {
		return [Constants.ENTITY_STATE_REMOVED, Constants.ENTITY_STATE_CANCELLED].includes(
			this.entityStatus,
		);
	}

	public get canRemoveEntity(): boolean {
		return [Constants.ENTITY_STATE_SIGNOFF, Constants.ENTITY_STATE_LIVE].includes(
			this.entityStatus,
		);
	}

	public get canCancelEntity(): boolean {
		return [Constants.ENTITY_STATE_PENDING, Constants.ENTITY_STATE_INSTALL].includes(
			this.entityStatus,
		);
	}
}
